import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from '../components/Header';
export const AdminLayout = () => {
  return <div className="min-h-screen bg-surface" data-id="element-1608">
      <Header data-id="element-1609" />
      <Outlet data-id="element-1610" />
    </div>;
};